import { Box, Button, Snackbar, Alert, MenuItem, FormControl, Select, Container, Grid, Typography, InputLabel, FormControlLabel, Autocomplete, TextField, Switch, Radio, RadioGroup, FormLabel, Checkbox, Accordion, AccordionSummary, AccordionDetails, Tabs, Tab } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Formik, Form, Field, useFormikContext } from 'formik';
import "./recruiter.scss";
import { useContext, useEffect, useState, useRef } from 'react';
import { CreateEmployerValidationSchema, CreateEmployerValidationSchemaPart2, CreateRecruiterValidationSchema, UpdateEmployerValidationSchema, AddEmployerCreditsValidationSchema } from '../../utils/Validations';
import { patchRequestWithToken, postRequest, getRequestWithToken, getRequest } from '../../utils/ApiRequests';
import { GlobalContext } from '../../components/GlobalStateProvide/GlobalStateProvider';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import FocusError from '../../components/FocusError/FocusError';
import ReusableLoader from "../../components/ReusableLoader/ReusableLoader";
import BackBtn from '../../components/backButton/BackBtn';
import { checkPermission } from '../../utils/userPermissions'
import Unauthorized from "../../components/unauthorized/Unauthorized";
import { useDropzone } from "react-dropzone";
import NorthIcon from '@mui/icons-material/North';
import CircularProgress from '@mui/material/CircularProgress';
import SectionCard from '../../ui/forms/SectionCard';


const CreateRecruiter = () => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [form2Submitted, setForm2Submitted] = useState(false);
  const [disableSubmitBtnTrue, setDisableSubmitBtnTrue] = useState(false);
  const { handleSnackBar } = useContext(GlobalContext);
  const location = useLocation();

  const [dataById, setDataById] = useState([]);
  const [showLoader, setShowLoader] = useState(true);

  const [canCreate, setCanCreate] = useState(true);
  const [canDelete, setCanDelete] = useState(true);
  const [canUpdate, setCanUpdate] = useState(true);
  const [canRead, setCanRead] = useState(true);
  const [isAccess, setisAccess] = useState([]);
  const [isIncludesValue, setisIncludesValue] = useState(true);

  const [fileImg, setFileImg] = useState(null);
  const [imageUploader, setImageUploader] = useState(false);
  const [fileData, setFileData] = useState([]);
  const [sector, setSector] = useState([]);
  const [plansData, setPlansData] = useState([]);
  const [employerID, setEmployerID] = useState(null);
  const [employerPhone, setEmployerPhone] = useState(null);
  const [uploadImage, setUploadImage] = useState([]);
  const [sectorObject, setSectorObject] = useState({});
  const [fetchingPincode, setfetchingPincode] = useState(false);

  // Credit form state
  const [addonList, setAddonList] = useState([]);
  const [loadingAddons, setLoadingAddons] = useState(false);

  const creditFormInitialValues = {
    creditMode: 'custom',
    creditType: 1,
    operation: 'credit',
    reason: '',
    systemMessage: '',
    creditAmount: '',
    validityDays: '',
    addonId: '',
    hasPaymentTransaction: false,
    amount: '',
    paymentMode: '',
    bankTransactionId: '',
    paymentGatewayTransactionId: '',
    paymentGatewayServiceTransactionId: '',
    bankId: '',
    arn: ''
  };

  const [initialValues, setInitialValues] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    usertype: "",
    companyName: "",
    fullAddress: "",
    city: "",
    state: "",
    pincode: "",
    password: "",
    image: "",
    email: "",
    companyEmail: "",
    businessRoles: "",
    sectorType: "",
    businessCategory: "",
    documentType: "",
    documentId: "",
    recruitOnBehalfOfClients: true,
    recruitmentAgency: "",
    isTester: false,
  })

  const [form2InitialValues, setForm2InitialValues] = useState({
    hasTransactionId: false,
    transactionId: "",
    plan: "",
    paymentGatewayTransactionId: "",
    paymentGatewayServiceTransactionId: "",
    paymentMode: "",
    bankTransactionId: "",
    bankId: "",
    arn: "",
    mobile: "",
    merchantTransactionId: "",
    paymentDate: ""
  })
  const [edit, setEdit] = useState(false);
  const [tabValue, setTabValue] = useState(0);

  // console.log(location, "this is location");
  const inputRefs = {};

  const scrollToErrorField = (fieldName) => {
    if (inputRefs[fieldName]) {
      inputRefs[fieldName].scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollTargetRef = useRef(null);
  const navigate = useNavigate();

  const handleSubmit = async (values, { resetForm }) => {
    setFormSubmitted(true);
    let sectorFind = sector.find((sector) => sector.sectorNameEn === "HR, Management & Other Professional Services");
    let formData = new FormData();
    if (edit) {
      formData.append("userid", location?.state?._id);
      formData.append("usertype", "employer");
      formData.append("firstName", values.firstName);
      formData.append("lastName", values.lastName);
      formData.append("phone", values.phone);
      formData.append("companyName", values.companyName);
      formData.append("fullAddress", values.fullAddress);
      formData.append("city", values.city);
      formData.append("state", values.state);
      formData.append("pincode", values.pincode);
      // formData.append("password", values.password);
      formData.append("businessRoles", values.businessRoles === 'Employee' ? 2 : 1);
      formData.append("email", values.email);
      formData.append("companyEmail", values.companyEmail);
      formData.append("image", uploadImage);
      formData.append("sectorType", sectorFind._id);
      formData.append("businessCategory", values.businessCategory === "Independent" ? "1" : "2");
      formData.append("documentType", values.documentType ? values.documentType : 0);
      formData.append("documentId", values.documentId === undefined ? "" : values.documentId);
      formData.append("recruitOnBehalfOfClients", true);
      formData.append("recruitmentAgency", values.recruitmentAgency === "Yes" ? true : false);
      formData.append("isTester", values.isTester ? true : false);
    }
    else {
      formData.append("usertype", "employer");
      formData.append("firstName", values.firstName);
      formData.append("lastName", values.lastName);
      formData.append("phone", values.phone);
      formData.append("companyName", values.companyName);
      formData.append("fullAddress", values.fullAddress);
      formData.append("city", values.city);
      formData.append("state", values.state);
      formData.append("pincode", values.pincode);
      formData.append("password", values.password);
      formData.append("businessRoles", values.businessRoles === 'Employee' ? 2 : 1);
      formData.append("email", values.email);
      formData.append("companyEmail", values.companyEmail);
      formData.append("image", uploadImage);
      formData.append("sectorType", sectorFind._id);
      formData.append("businessCategory", values.businessCategory === "Independent" ? "1" : "2");
      formData.append("documentType", values.documentType ? values.documentType : 0);
      formData.append("documentId", values.documentId === undefined ? "" : values.documentId);
      formData.append("recruitOnBehalfOfClients", true);
      formData.append("recruitmentAgency", values.recruitmentAgency === "Yes" ? true : false);
      formData.append("isTester", values.isTester ? true : false);
    }

    try {
      let res = edit ?
        await patchRequestWithToken('admin', formData) : await postRequest('admin', formData);
      if (res.data.status === 'Success') {
        setFormSubmitted(false);
        if (!edit) {
          // resetForm();
          if (scrollTargetRef.current) {
            scrollTargetRef.current.scrollIntoView({ behavior: 'smooth' });
          }
          handleSnackBar(true, res.data.msg, "success");
          setEmployerPhone(res?.data?.phone);
          // setTimeout(() => {
          //   navigate('/recruiter');
          // }, 1000);
        }
        else {
          handleSnackBar(true, res.data.msg, "success");
          // setTimeout(() => {
          //   navigate('/recruiter');
          // }, 1000);
        }

      }
      else {
        setFormSubmitted(false);
        handleSnackBar(true, res.data.msg, "error")
      }
    } catch (err) {
      console.log(err);
      setFormSubmitted(false);
      handleSnackBar(true, err?.response?.data?.msg, "error")
    }
  }

  const handleForm2Submit = async (values) => {
    setForm2Submitted(true);

    // Format payment date to ISO 8601 format with time
    const formatPaymentDate = (dateString) => {
      if (!dateString) return null;
      const date = new Date(dateString);
      date.setHours(18, 30, 0, 0); // Set time to 18:30:00
      return date.toISOString();
    };

    let data = {
      "planId": values?.plan,
      "orderType": "plan",
      "isBetaVersion": false,
      "employerId": employerID,
      "phone": employerPhone,
    };
    console.log(data, "this is values of form2");

    // Add transaction ID or payment data based on user selection
    if (values?.hasTransactionId) {
      data.transactionId = values?.transactionId;
      data.paymentData = null;
    } else {
      data.transactionId = null;
      data.paymentData = {
        paymentGatewayTransactionId: values?.paymentGatewayTransactionId,
        paymentGatewayServiceTransactionId: values?.paymentGatewayServiceTransactionId,
        paymentMode: values?.paymentMode,
        bankTransactionId: values?.bankTransactionId,
        bankId: values?.bankId,
        arn: values?.arn,
        mobile: values?.mobile,
        merchantTransactionId: values?.merchantTransactionId,
        paymentDate: formatPaymentDate(values?.paymentDate)
      };
    }

    try {
      let res = await postRequest('admin/order-summary', data);
      if (res.data.status === 'Success') {
        setForm2Submitted(false);
        setDisableSubmitBtnTrue(true);
        handleSnackBar(true, res.data.msg, "success");
        setTimeout(() => {
          navigate('/recruiter');
        }, 1000);
      }
      else {
        setForm2Submitted(false);
        handleSnackBar(true, res.data.msg, "error")
      }
    } catch (err) {
      console.log(err);
      setForm2Submitted(false);
      handleSnackBar(true, err?.response?.data?.msg, "error")
    }
  }
  const fetchPincodeDetails = async (pincode, setFieldValue) => {
    setfetchingPincode(true);
    try {
      console.log(pincode)
      let response = await getRequest(`pincode/${pincode}`);
      const data = response.data.data;
      // Set values using setFieldValue
      // setFieldValue('village', data.village);
      setFieldValue('district', data.Districtname);
      setFieldValue('state', data.statename);
      setFieldValue('city', data.Taluk);
      setfetchingPincode(false);
    } catch (err) {
      console.log(err)
      setfetchingPincode(false);
    }
  }


  const getEmployerById = async () => {
    try {
      let response = await getRequestWithToken(`admin/userbyid/?usertype=employer&userid=${location.state?._id}`);
      setDataById(response.data.data)
      setEmployerID(response.data.data._id);
      setEmployerPhone(response.data.data.phone);
      setShowLoader(false);
    } catch (error) {
      handleSnackBar(true, error?.response?.data?.msg || error?.message, "error");
      setShowLoader(false);
    }
  }

  const checkPermissionFunc = () => {
    const resourceToUpdate = "Recruiter";
    const permissions = checkPermission(resourceToUpdate);
    setCanCreate(permissions.canCreate)
    setCanDelete(permissions.canDelete)
    setCanUpdate(permissions.canUpdate)
    setCanRead(permissions.canRead)
  }

  const againCheckPermissions = () => {
    // console.log("hello")
    const checkAccesInArray = localStorage.getItem("resourceNames");
    // console.log("resourceNames : " + checkAccesInArray);
    setisAccess(checkAccesInArray);
    isIncludes();
  }

  const isIncludes = () => {
    setisIncludesValue(isAccess.includes("Recruiter"))
  }

  const getAllEmployers = async () => {
    try {
      let response = await getRequestWithToken(
        `/admin/plan?planStatus=active`
      );
      setPlansData(response?.data?.data);
    } catch (error) {
      handleSnackBar(
        true,
        error?.response?.data?.msg || error?.message,
        "error"
      );
    }
  };

  const getSectors = async () => {
    try {
      let data = await getRequestWithToken("admin/sectors");
      if (data.data.status === "Success") {
        setSector([...data.data.data]);
      }
    } catch (error) {
      handleSnackBar(true, error?.response?.data?.msg || error?.msg, "error");
    }
  };

  // Credit Management Functions
  const fetchAddons = async (creditType) => {
    setLoadingAddons(true);
    try {
      const response = await getRequestWithToken(`admin/addon?type=${creditType}`);
      setAddonList(response?.data?.data || []);
    } catch (error) {
      handleSnackBar(true, error?.response?.data?.msg || error?.message, "error");
      setAddonList([]);
    } finally {
      setLoadingAddons(false);
    }
  };

  const handleAddonChange = (e, setFieldValue, creditType) => {
    const selectedAddonId = e.target.value;
    setFieldValue('addonId', selectedAddonId);

    const selectedAddon = addonList.find(addon => addon._id === selectedAddonId);
    if (selectedAddon) {
      setFieldValue('creditAmount', creditType === 1 ? selectedAddon.hcCredit : selectedAddon.phcCredit || 0);
      setFieldValue('validityDays', selectedAddon.expiryDuration);
      setFieldValue('amount', selectedAddon.amount);
    }
  };

  const handleCreditFormSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const payload = {
        employerId: dataById._id,
        creditType: values.creditType,
        operation: values.operation,
        reason: values.reason,
        systemMessage: values.systemMessage
      };

      if (values.creditMode === 'custom') {
        payload.creditAmount = Number(values.creditAmount);
        if (values.operation === 'credit') {
          payload.validityDays = Number(values.validityDays);
        }
      } else {
        payload.addonId = values.addonId;
      }

      if (values.hasPaymentTransaction) {
        payload.amount = Number(values.amount);
        payload.paymentMode = values.paymentMode;
        payload.bankTransactionId = values.bankTransactionId;
        payload.paymentGatewayTransactionId = values.paymentGatewayTransactionId;
        payload.paymentGatewayServiceTransactionId = values.paymentGatewayServiceTransactionId;
        payload.bankId = values.bankId;
        payload.arn = values.arn;
      }

      const response = await postRequest('admin/employer/add-credits', payload);

      if (response?.data?.status === 'Success') {
        handleSnackBar(true, response?.data?.msg || 'Credits updated successfully', 'success');
        resetForm();
        setAddonList([]);
        // Optionally refresh employer data
        if (dataById._id) {
          getEmployerById();
        }
      }
    } catch (error) {
      handleSnackBar(true, error?.response?.data?.msg || error?.message, 'error');
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    getSectors();
    getAllEmployers();
  }, [])


  useEffect(() => {

    checkPermissionFunc();
    againCheckPermissions();

    if (location.state?._id) {
      getEmployerById()
    }
    else {
      setShowLoader(false);
    }


    if (location?.state?._id) {
      const { employer = {} } = dataById;
      const foundObject = sector.find(obj => obj._id === dataById?.sectorType);
      setFileImg(dataById?.businessLogo);
      setSectorObject(foundObject);
      const {
        usertype = "employer",
        companyName = dataById?.companyName,
        firstName = dataById?.firstName,
        lastName = dataById?.lastName,
        phone = dataById?.phone,
        companyEmail = dataById?.companyEmail,
        fullAddress = dataById?.companyAddress?.fullAddress,
        city = dataById?.companyAddress?.city,
        state = dataById?.companyAddress?.state,
        pincode = dataById?.companyAddress?.pincode,
        password = dataById?.password,
        image = dataById?.businessLogo,
        email = dataById?.email,
        businessRoles = dataById?.businessRoles === 1 ? "Business Owner" : "Employee",
        sectorType = foundObject,
        businessCategory = dataById?.businessCategory === 1 ? "Independent" : "Registered",
        documentType = dataById?.kycDetails?.documentType === 0 ? "" : dataById?.kycDetails?.documentType,
        documentId = dataById?.kycDetails?.documentId ? dataById?.kycDetails?.documentId : "",
        recruitOnBehalfOfClients = dataById?.recruitOnBehalfOfClients === false ? "Employer" : "Recruiter",
        recruitmentAgency = dataById?.recruitmentAgency === false ? "No" : "Yes",
      } = employer;

      setInitialValues({
        usertype,
        firstName,
        lastName,
        phone,
        companyEmail,
        companyName,
        fullAddress,
        city,
        state,
        pincode,
        password,
        image,
        email,
        businessRoles,
        sectorType,
        businessCategory,
        documentType,
        documentId,
        recruitOnBehalfOfClients,
        recruitmentAgency,
        isTester: dataById?.isTester || false,
      });

      setForm2InitialValues({
        hasTransactionId: !!dataById?.transactionId,
        transactionId: dataById?.transactionId || "",
        plan: dataById?.currentPlanInfo?.planId || dataById?.plan || "",
        paymentGatewayTransactionId: dataById?.paymentData?.paymentGatewayTransactionId || "",
        paymentGatewayServiceTransactionId: dataById?.paymentData?.paymentGatewayServiceTransactionId || "",
        paymentMode: dataById?.paymentData?.paymentMode || "",
        bankTransactionId: dataById?.paymentData?.bankTransactionId || "",
        bankId: dataById?.paymentData?.bankId || "",
        arn: dataById?.paymentData?.arn || "",
        mobile: dataById?.paymentData?.mobile || "",
        merchantTransactionId: dataById?.paymentData?.merchantTransactionId || "",
        paymentDate: dataById?.paymentData?.paymentDate || ""
      });

      setEdit(true);
    } else {
      setInitialValues({
        usertype: "",
        firstName: "",
        lastName: "",
        phone: "",
        companyEmail: "",
        companyName: "",
        fullAddress: "",
        city: "",
        state: "",
        pincode: "",
        password: "",
        image: "",
        email: "",
        businessRoles: "",
        sectorType: "",
        businessCategory: "",
        // recruitOnBehalfOfClients,
        documentType: "",
        documentId: "",
        recruitmentAgency: "",
        isTester: false,
      });

      setForm2InitialValues({
        hasTransactionId: false,
        transactionId: "",
        plan: "",
        paymentGatewayTransactionId: "",
        paymentGatewayServiceTransactionId: "",
        paymentMode: "",
        bankTransactionId: "",
        bankId: "",
        arn: "",
        mobile: "",
        merchantTransactionId: "",
        paymentDate: ""
      });


      setEdit(false);
    }
  }, [location.state, dataById._id, isIncludesValue, sector])

  const MAX_FILE_SIZE = 2 * 1024 * 1024; // 5 MB in bytes
  const onDrop = (acceptedFiles) => {

    const oversizedFiles = acceptedFiles.filter(file => file.size > MAX_FILE_SIZE);
    if (oversizedFiles.length > 0) {
      handleSnackBar(true, "File size exceeds the maximum limit of 2 MB", "error")
      return;
    }

    setFileData(acceptedFiles);
    acceptedFiles.forEach((file, index) => {
      let url = URL.createObjectURL(file);
      if (index === 0) setFileImg(url);
    });

    setUploadImage(acceptedFiles[0]);
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop
  });

  return (
    (isIncludesValue) ? <>
      {showLoader ? <ReusableLoader /> : <Box className="create-employer-section" ref={scrollTargetRef}>

        <Container>
          <Box className="create-employer">
            <Box className="headingPlusBackBtn">
              <BackBtn />
              <h1 className='formHeadings'>{edit ? "Update Recruiter" : "Create Recruiter"}</h1>
            </Box>

            {/* Tabs - Only visible in edit mode */}
            {edit && dataById._id && (
              <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
                <Tabs value={tabValue} onChange={(e, newValue) => setTabValue(newValue)} aria-label="recruiter edit tabs">
                  <Tab label="Recruiter Information" />
                  <Tab label="Credit Settings" />
                </Tabs>
              </Box>
            )}

            {/* Tab 1: Recruiter Information (or only content if not in edit mode) */}
            {(!edit || tabValue === 0) && (
              <>
                <Box className="create-employer-form-wrapper">
                  <Formik
                    initialValues={initialValues}
                    validationSchema={CreateRecruiterValidationSchema}
                    onSubmit={handleSubmit}
                    enableReinitialize
                  >
                    {({ errors, values, setFieldValue, resetForm }) => (

                      <Form className="create-employer-form ">

                        <Box className="backgroundStyle">
                          <Grid container spacing={2} className='cstmFormGridEmployer'>

                            <Grid item xs={12} sm={8} md={6}>
                              <Box className="form-control" >
                                <label className="form-label" htmlFor="businessCategory">Choose Business Category<span className='must-fill-fields'>*</span></label>
                                <div role="group" aria-labelledby="radio-group">
                                  <Grid container spacing={2} >
                                    {['Registered', 'Independent'].map((item, index) => (
                                      <Grid item xs={12} sm={6} md={6} key={index}>
                                        <Box className="form-control">
                                          <label key={index} className='form-label months_label' htmlFor={item}>
                                            <Field type="radio" id={item} name="businessCategory" value={item} />
                                            {item}
                                          </label>
                                        </Box>
                                      </Grid>

                                    ))}
                                  </Grid>
                                </div>
                                {errors.businessCategory && <Box className="form-error">{errors.businessCategory}</Box>}
                              </Box>
                            </Grid>

                            <Grid item xs={12} sm={8} md={6}>
                              <Box className="form-control" >
                                <label className="form-label" htmlFor="recruitOnBehalfOfClients">Dashboard Type<span className='must-fill-fields'>*</span></label>
                                <div role="group" aria-labelledby="radio-group">
                                  <Grid container spacing={2} >
                                    {['Recruiter', 'Employer'].map((item, index) => (
                                      <Grid item xs={12} sm={6} md={6} key={index}>
                                        <Box className="form-control">
                                          <label key={index} className='form-label months_label' htmlFor={item}>
                                            <Field type="radio" id={item} name="recruitOnBehalfOfClients" value={item} checked={item === 'Recruiter'} />
                                            {item}
                                          </label>
                                        </Box>
                                      </Grid>
                                    ))}
                                  </Grid>
                                </div>
                                {errors.recruitOnBehalfOfClients && <Box className="form-error">{errors.recruitOnBehalfOfClients}</Box>}
                              </Box>
                            </Grid>

                            <Grid item xs={12} sm={8} md={6}>
                              <Box className="form-control" >
                                <label className="form-label" htmlFor="recruitmentAgency">Is Recruitment Agency?<span className='must-fill-fields'>*</span></label>
                                <div role="group" aria-labelledby="radio-group">
                                  <Grid container spacing={2} >
                                    {['Yes', 'No'].map((item, index) => (
                                      <Grid item xs={12} sm={6} md={6} key={index}>
                                        <Box className="form-control">
                                          <label key={index} className='form-label months_label' htmlFor={item}>
                                            <Field type="radio" id={item} name="recruitmentAgency" value={item} />
                                            {item}
                                          </label>
                                        </Box>
                                      </Grid>

                                    ))}
                                  </Grid>
                                </div>
                                {errors.recruitmentAgency && <Box className="form-error">{errors.recruitmentAgency}</Box>}
                              </Box>
                            </Grid>
                            <Grid item xs={12} sm={8} md={6}>
                              <Box className="form-control">
                                <label className="form-label">Is Test Account?</label>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={!!values.isTester}
                                      onChange={(e) => setFieldValue("isTester", e.target.checked)}
                                      color="warning"
                                    />
                                  }
                                  label={values.isTester ? "Yes (Tester)" : "No"}
                                />
                              </Box>
                            </Grid>
                          </Grid>

                          <Grid container spacing={2} className='cstmFormGridEmployer'>
                            <Grid item xs={12} sm={6} md={4}>
                              <Box className="form-control" >
                                <label className="form-label" htmlFor="firstName"> First Name <span className='must-fill-fields'>*</span></label>
                                <Field id="firstName"
                                  type="text" placeholder="Enter First Name"
                                  name="firstName"
                                  className="form-input" size="small"
                                />
                                {errors.firstName && <Box className="form-error">{errors.firstName}</Box>}

                              </Box>
                            </Grid>



                            <Grid item xs={12} sm={6} md={4} >
                              <Box className="form-control">
                                <label className="form-label" htmlFor="lastName">Last Name <span className='must-fill-fields'>*</span></label>
                                <Field id="lastName"
                                  type="text" placeholder="Enter Last Name"
                                  name="lastName"
                                  className="form-input" />
                                {errors.lastName && <Box className="form-error">{errors.lastName}</Box>}
                              </Box>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4} >
                              <Box className="form-control">
                                <label className="form-label" htmlFor="phone">Mobile Number<span className='must-fill-fields'>*</span></label>
                                <Field id="phone"
                                  type="text" placeholder="Enter Mobile Number"
                                  name="phone"
                                  className="form-input"
                                  maxLength={10}
                                />
                                {errors.phone && <Box className="form-error">{errors.phone}</Box>}
                              </Box>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                              <Box className="form-control">
                                <label className="form-label" htmlFor="email">Email <span className='must-fill-fields'>*</span></label>
                                <Field
                                  id="email"
                                  type="text" placeholder="Enter Email"
                                  name="email"
                                  className="form-input" />
                                {errors.email && <Box className="form-error">{errors.email}</Box>}
                              </Box>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                              <Box className="form-control">
                                <label className="form-label" htmlFor="password">Create Password <span className='must-fill-fields'>*</span></label>
                                <Field id="password"
                                  disabled={edit}
                                  type="text" placeholder="create password"
                                  name="password"
                                  className="form-input" />
                                {errors.password && <Box className="form-error">{errors.password}</Box>}
                              </Box>
                            </Grid>

                          </Grid>



                          <Grid container spacing={2} className='cstmFormGridEmployer'>



                            <Grid item xs={12} sm={12} md={12} style={{ marginTop: "20px" }}>
                              <Typography style={{ fontWeight: "700" }}>Company Address</Typography>
                            </Grid>

                            <Grid item xs={12} sm={6} md={6}>
                              <Box className="form-control">
                                <label className="form-label" htmlFor="companyName"> Company Name  <span className='must-fill-fields'>*</span></label>
                                <Field innerRef={(el) => { inputRefs.companyName = el }} id="companyName"
                                  type="text" placeholder="Enter Company Name"
                                  name="companyName"
                                  className="form-input" />
                                {errors.companyName && <Box className="form-error">{errors.companyName}</Box>}
                              </Box>

                            </Grid>

                            <Grid item xs={12} sm={6} md={6}>
                              <Box className="form-control">
                                <label className="form-label" htmlFor="companyEmail"> Company Email <span className='must-fill-fields'>*</span></label>
                                <Field
                                  id="companyEmail"
                                  type="text" placeholder="Enter Company Email"
                                  name="companyEmail"
                                  className="form-input" />
                                {errors.companyEmail && <Box className="form-error">{errors.companyEmail}</Box>}
                              </Box>
                            </Grid>
                          </Grid>

                          <Grid container spacing={2} className='cstmFormGridEmployer'>
                            <Grid item xs={12} sm={6} md={6}>
                              <Box className="form-control">
                                <label className="form-label" htmlFor="fullAddress">Address <span className='must-fill-fields'>*</span></label>
                                <Field
                                  innerRef={(el) => { inputRefs.fullAddress = el }}

                                  id="fullAddress"

                                  type="text" placeholder="Enter Adress"
                                  name="fullAddress"
                                  className="form-input" />
                                {errors.fullAddress && <Box className="form-error">{errors.fullAddress}</Box>}
                              </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                              <Box className="form-control">
                                <label className="form-label" style={{ display: 'flex', alignItems: 'center', gap: "10px" }} htmlFor="pincode"> Pincode <span className='must-fill-fields'>*</span>{fetchingPincode && <CircularProgress style={{ width: '20px', height: '20px' }} />} </label>
                                <Field id="pincode"
                                  type="text" placeholder="Enter pincode"
                                  name="pincode"
                                  className="form-input"
                                  onBlur={(e) => fetchPincodeDetails(e.target.value, setFieldValue)}
                                // onChange={getPincode}
                                />
                                {errors.pincode && <Box className="form-error">{errors.pincode}</Box>}
                              </Box>
                            </Grid>


                            <Grid item xs={12} sm={6} md={6}>
                              <Box className="form-control">
                                <label className="form-label" htmlFor="city">City <span className='must-fill-fields'>*</span></label>
                                <Field id="city"
                                  type="text" placeholder="Enter city"
                                  name="city"
                                  className="form-input" />
                                {errors.city && <Box className="form-error">{errors.city}</Box>}
                              </Box>
                            </Grid>

                            <Grid item xs={12} sm={6} md={6}>
                              <Box className="form-control">
                                <label className="form-label" htmlFor="state">State <span className='must-fill-fields'>*</span></label>
                                <Field disabled={edit} id="state"
                                  type="text" placeholder="Enter state"
                                  name="state"
                                  className="form-input" />
                                {errors.state && <Box className="form-error">{errors.state}</Box>}
                              </Box>
                            </Grid>
                          </Grid>

                          <Grid container spacing={2} className='cstmFormGridEmployer'>

                            <Grid item xs={12} sm={12} md={6}>
                              <Box className="form-control">
                                <label className="form-label" htmlFor="sectorType">
                                  Company Sector<span className="must-fill-fields">*</span>
                                </label>
                                <TextField
                                  disabled
                                  size='small'
                                  value='HR, Management & Other Professional Services' />
                                {/* <Autocomplete
                              id="tags-outlined"
                              options={sector || []}
                              getOptionLabel={(option) => option.sectorNameEn}
                              filterSelectedOptions
                              value={sector.find((option) => option._id === values.sectorType?._id) || null}
                              onChange={(event, newValue) => {
                                setFieldValue('sectorType', newValue);
                              }}
                              renderInput={(params) => (
                                <TextField {...params} placeholder="Select Sector" />
                              )}
                            /> */}
                                {errors.sectorType && (
                                  <Box className="form-error">{errors.sectorType}</Box>
                                )}
                              </Box>
                            </Grid>

                            <Grid item xs={12} sm={8} md={6}>
                              <Box className="form-control" >
                                <label className="form-label" htmlFor="businessRoles">Your Designation<span className='must-fill-fields'>*</span></label>
                                <div role="group" aria-labelledby="radio-group">
                                  <Grid container spacing={2} >
                                    {['Employee', 'Business Owner'].map((item, index) => (
                                      <Grid item xs={12} sm={6} md={6} key={index}>
                                        <Box className="form-control">
                                          <label key={index} className='form-label months_label' htmlFor={item}>
                                            <Field type="radio" id={item} name="businessRoles" value={item} />
                                            {item}
                                          </label>
                                        </Box>
                                      </Grid>

                                    ))}
                                  </Grid>
                                </div>
                                {errors.businessRoles && <Box className="form-error">{errors.businessRoles}</Box>}
                              </Box>
                            </Grid>

                          </Grid>

                          <Grid container spacing={2} className='cstmFormGridEmployer'>

                            <Grid item xs={12} sm={12} md={12} style={{ marginTop: "20px" }}>
                              <Typography style={{ fontWeight: "700" }}>KYC Details</Typography>
                            </Grid>

                            <Grid item xs={12} sm={6} md={6}>
                              <Box className="form-control">
                                <label className="form-label" htmlFor="documentType">Document Type <span className='must-fill-fields'>*</span></label>
                                <FormControl name="documentType" fullWidth size="small">
                                  {values.documentType === "" && <InputLabel shrink={false}>Select Document Type </InputLabel>}
                                  <Select
                                    displayEmpty
                                    name="documentType"
                                    id="documentType"
                                    value={values.documentType}
                                    onChange={(event) => {
                                      const selectedDocumentTypeValue = event.target.value;
                                      setFieldValue("documentType", selectedDocumentTypeValue);
                                    }}
                                  >

                                    <MenuItem value="1" >GST</MenuItem>
                                    <MenuItem value="2">CIN</MenuItem>
                                    <MenuItem value="4">Udhyam Aadhar</MenuItem>
                                    <MenuItem value="3">{values.businessCategory === "Independent" ? "PAN" : "Business PAN"}</MenuItem>
                                  </Select>
                                </FormControl>
                                {errors.documentType && <Box className="form-error">{errors.documentType}</Box>}
                              </Box>
                            </Grid>

                            <Grid item xs={12} sm={6} md={6}>
                              <Box className="form-control">
                                <label className="form-label" htmlFor="documentId">Document ID <span className='must-fill-fields'>*</span></label>
                                <Field id="documentId"
                                  disabled={values.documentType === "" ? true : false}
                                  type="text" placeholder="Document ID"
                                  name="documentId"
                                  className="form-input" />
                                {errors.documentId && <Box className="form-error">{errors.documentId}</Box>}
                              </Box>
                            </Grid>

                            <Grid item xs={12} sm={12} md={12}>
                              <Box className="mt-5 px-4 py-3">

                                <label className="form-label" htmlFor="image"> Upload your Business Logo</label>

                                <Grid justifyContent="center" className='' style={{ border: "1px solid #e4e3e3", borderRadius: "5px", backgroundColor: "white" }} item xs={12}>
                                  <Box display="flex" className="cursor-pointer items-center flex-col" style={{ position: "relative" }} justifyContent="center" width="100%">
                                    {<Box {...getRootProps({ className: 'dropzone' })} className="" style={{ textAlign: "center", minHeight: "180px", display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                                      {fileImg !== null && <img style={{ height: "100%", width: "100%", display: "block", objectFit: "cover", maxHeight: "180px" }} src={fileImg} alt="selected png, svg" />}

                                      {fileImg === null && <>
                                        <input {...getInputProps()} />
                                        <NorthIcon color="text-secondary-black" fontSize="small" />
                                        <Typography className="text-secondary-black text-xs md:text-base font-medium ">
                                          Upload Here
                                        </Typography>
                                        <Typography className="text-secondary-black text-xs md:text-base font-medium ">
                                          File types supported: jpg, jpeg, png
                                        </Typography>
                                        <Typography className="text-secondary-black text-xs md:text-base font-medium ">
                                          Maximum file size: 2 MB
                                        </Typography></>}
                                    </Box>}

                                    {imageUploader && <Box className="loaderClass" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '300px' }} >
                                      <CircularProgress />
                                    </Box>}
                                  </Box>

                                  {errors.businessLogo && <Typography fontSize="14px" color="#d32f2f" marginTop={2} textAlign="center">{errors.businessLogo.message}</Typography>}
                                </Grid>
                                <Typography onClick={() => { setFileImg(null); setUploadImage([]) }} style={{ color: "#ff671f", cursor: "pointer" }}>Change</Typography>
                              </Box>
                            </Grid>
                          </Grid>
                        </Box>

                        <Box className="form-button-section">
                          <Link to='/employer'>
                            <Button className="form-button"
                              variant="contained"
                              onClick={() => {
                                resetForm();
                              }}
                              color="error"
                            >Cancel</Button>
                          </Link>

                          <Button className="form-button"
                            variant="contained"
                            type="submit"
                            color="success"
                            disabled={formSubmitted}
                          >
                            {formSubmitted ? <CircularProgress size={24} /> :
                              edit ? "Update" : "Create"}
                          </Button>

                        </Box>
                        <FocusError handleSnackBar={handleSnackBar} />
                      </Form>
                    )}
                  </Formik>
                </Box>
                <Box className="create-employer-form-wrapper" style={{ marginTop: "40px" }}>
                  {/* {dataById?.onBoardingStep} */}
                  <Formik
                    initialValues={form2InitialValues}
                    onSubmit={handleForm2Submit}
                    validationSchema={CreateEmployerValidationSchemaPart2}
                    enableReinitialize
                  >
                    {({ errors, values, setFieldValue }) => (
                      <Form className="create-employer-form">
                        {/* Onboarding Complete Section */}
                        <SectionCard title="Onboarding Final Steps" subtitle="Complete payment details and plan setup">
                          <Box style={{
                            backgroundColor: disableSubmitBtnTrue || (dataById?.onBoardingStep === 5 && dataById?.isOnBoarded === true) ? '#e8f5e9' : 'white',
                            opacity: disableSubmitBtnTrue || (dataById?.onBoardingStep === 5 && dataById?.isOnBoarded === true) ? 0.7 : 1,
                            border: disableSubmitBtnTrue || (dataById?.onBoardingStep === 5 && dataById?.isOnBoarded === true) ? '2px solid #4caf50' : 'none',
                            borderRadius: '8px',
                            position: 'relative',
                            padding: '10px'
                          }}>
                            <Grid container spacing={2} className='cstmFormGridEmployer'>
                              <Grid item xs={12} sm={12} md={12}>
                                <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                  <Typography style={{ fontWeight: "700", fontSize: "18px", marginBottom: "10px" }}>
                                    Onboarding Final Steps
                                  </Typography>
                                  {disableSubmitBtnTrue || (dataById?.onBoardingStep === 5 && dataById?.isOnBoarded === true) && (
                                    <Box style={{
                                      backgroundColor: '#4caf50',
                                      color: 'white',
                                      padding: '6px 12px',
                                      borderRadius: '4px',
                                      fontSize: '14px',
                                      fontWeight: '600'
                                    }}>
                                      ✓ Completed
                                    </Box>
                                  )}
                                </Box>
                              </Grid>

                              <Grid item xs={12} sm={6} md={6}>
                                <Box className="form-control">
                                  <label className="form-label" htmlFor="plan">
                                    Choose Plan<span className="must-fill-fields">*</span>
                                  </label>
                                  <Autocomplete
                                    id="plan"
                                    options={plansData || []}
                                    getOptionLabel={(option) => `${option.planName}`}
                                    filterSelectedOptions
                                    disabled={dataById?.onBoardingStep === 5 && dataById?.isOnBoarded === true}
                                    value={plansData.find((option) => option._id === values.plan) || null}
                                    onChange={(event, newValue) => {
                                      setFieldValue('plan', newValue?._id || '');
                                    }}
                                    renderInput={(params) => (
                                      <TextField {...params} placeholder="Select Plan" />
                                    )}
                                    renderOption={(props, option) => (
                                      <Box {...props}>
                                        <Box>
                                          <div style={{ fontWeight: 500 }}>{option.planName}</div>
                                          <div style={{ fontSize: '0.85rem', color: '#666' }}>
                                            Code: {option.planCode} | Amount: ₹{option.planMetaData?.[0]?.planAmount || 0}
                                          </div>
                                        </Box>
                                      </Box>
                                    )}
                                  />
                                  {errors.plan && (
                                    <Box className="form-error">{errors.plan}</Box>
                                  )}
                                </Box>
                              </Grid>

                              {/* <Grid item xs={12} sm={6} md={6}>
                          <Box className="form-control" style={{ marginTop: "26px" }}>
                            <FormControlLabel
                              label="Do you have a Transaction ID?"
                              disabled={dataById?.onBoardingStep === 5 && dataById?.isOnBoarded === true}
                              control={
                                <Switch
                                  disabled={dataById?.onBoardingStep === 5 && dataById?.isOnBoarded === true}
                                  checked={values.hasTransactionId}
                                  onChange={(e) => {
                                    setFieldValue('hasTransactionId', e.target.checked);
                                  }}
                                  color="primary"
                                />
                              }
                            />
                          </Box>
                        </Grid> */}

                              {/* {values.hasTransactionId ? (
                          <>
                            <Grid item xs={12} sm={6} md={6}>
                              <Box className="form-control">
                                <label className="form-label" htmlFor="transactionId">Transaction ID <span className='must-fill-fields'>*</span></label>
                                <Field
                                  disabled={dataById?.onBoardingStep === 5 && dataById?.isOnBoarded === true}
                                  id="transactionId"
                                  type="text"
                                  placeholder="Enter Transaction ID"
                                  name="transactionId"
                                  className="form-input"
                                />
                                {errors.transactionId && <Box className="form-error">{errors.transactionId}</Box>}
                              </Box>
                            </Grid>
                          </>
                        ) : ( */}
                              <>
                                <Grid item xs={12} sm={6} md={6}>
                                  <Box className="form-control">
                                    <label className="form-label" htmlFor="paymentMode">Payment Mode<span className='must-fill-fields'>*</span></label>
                                    <FormControl fullWidth size="small" disabled={dataById?.onBoardingStep === 5 && dataById?.isOnBoarded === true}>
                                      {values.paymentMode === "" && <InputLabel shrink={false}>Select Payment Mode</InputLabel>}
                                      <Select
                                        displayEmpty
                                        disabled={dataById?.onBoardingStep === 5 && dataById?.isOnBoarded === true}
                                        name="paymentMode"
                                        id="paymentMode"
                                        value={values.paymentMode}
                                        onChange={(event) => {
                                          setFieldValue("paymentMode", event.target.value);
                                        }}
                                      >
                                        <MenuItem value="NETBANKING">Net Banking</MenuItem>
                                        <MenuItem value="CREDITCARD">Credit Card</MenuItem>
                                        <MenuItem value="DEBITCARD">Debit Card</MenuItem>
                                        <MenuItem value="UPI">UPI</MenuItem>
                                      </Select>
                                    </FormControl>
                                    {errors.paymentMode && <Box className="form-error">{errors.paymentMode}</Box>}
                                  </Box>
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                  <Box className="form-control">
                                    <label className="form-label" htmlFor="merchantTransactionId">Merchant Transaction ID<span className='must-fill-fields'>*</span></label>
                                    <Field
                                      disabled={dataById?.onBoardingStep === 5 && dataById?.isOnBoarded === true}
                                      id="merchantTransactionId"
                                      type="text"
                                      placeholder="Enter Merchant Transaction ID"
                                      name="merchantTransactionId"
                                      className="form-input"
                                    />
                                    {errors.merchantTransactionId && <Box className="form-error">{errors.merchantTransactionId}</Box>}
                                  </Box>
                                </Grid>

                                <Grid item xs={12} sm={6} md={6}>
                                  <Box className="form-control">
                                    <label className="form-label" htmlFor="mobile">Mobile<span className='must-fill-fields'>*</span></label>
                                    <Field
                                      disabled={dataById?.onBoardingStep === 5 && dataById?.isOnBoarded === true}
                                      id="mobile"
                                      type="text"
                                      placeholder="Enter Mobile Number"
                                      name="mobile"
                                      className="form-input"
                                      maxLength={10}
                                    />
                                    {errors.mobile && <Box className="form-error">{errors.mobile}</Box>}
                                  </Box>
                                </Grid>

                                <Grid item xs={12} sm={6} md={6}>
                                  <Box className="form-control">
                                    <label className="form-label" htmlFor="paymentDate">Payment Date<span className='must-fill-fields'>*</span></label>
                                    <Field
                                      disabled={dataById?.onBoardingStep === 5 && dataById?.isOnBoarded === true}
                                      id="paymentDate"
                                      type="date"
                                      placeholder="Select Payment Date"
                                      name="paymentDate"
                                      className="form-input"
                                    />
                                    {errors.paymentDate && <Box className="form-error">{errors.paymentDate}</Box>}
                                  </Box>
                                </Grid>

                                <Grid item xs={12} sm={6} md={6}>
                                  <Box className="form-control">
                                    <label className="form-label" htmlFor="paymentGatewayTransactionId">Payment Gateway Transaction ID</label>
                                    <Field
                                      disabled={dataById?.onBoardingStep === 5 && dataById?.isOnBoarded === true}
                                      id="paymentGatewayTransactionId"
                                      type="text"
                                      placeholder="Enter Payment Gateway Transaction ID"
                                      name="paymentGatewayTransactionId"
                                      className="form-input"
                                    />
                                    {errors.paymentGatewayTransactionId && <Box className="form-error">{errors.paymentGatewayTransactionId}</Box>}
                                  </Box>
                                </Grid>

                                <Grid item xs={12} sm={6} md={6}>
                                  <Box className="form-control">
                                    <label className="form-label" htmlFor="paymentGatewayServiceTransactionId">Payment Gateway Service Transaction ID</label>
                                    <Field
                                      disabled={dataById?.onBoardingStep === 5 && dataById?.isOnBoarded === true}
                                      id="paymentGatewayServiceTransactionId"
                                      type="text"
                                      placeholder="Enter Service Transaction ID"
                                      name="paymentGatewayServiceTransactionId"
                                      className="form-input"
                                    />
                                    {errors.paymentGatewayServiceTransactionId && <Box className="form-error">{errors.paymentGatewayServiceTransactionId}</Box>}
                                  </Box>
                                </Grid>



                                <Grid item xs={12} sm={6} md={6}>
                                  <Box className="form-control">
                                    <label className="form-label" htmlFor="bankTransactionId">Bank Transaction ID</label>
                                    <Field
                                      disabled={dataById?.onBoardingStep === 5 && dataById?.isOnBoarded === true}
                                      id="bankTransactionId"
                                      type="text"
                                      placeholder="Enter Bank Transaction ID"
                                      name="bankTransactionId"
                                      className="form-input"
                                    />
                                    {errors.bankTransactionId && <Box className="form-error">{errors.bankTransactionId}</Box>}
                                  </Box>
                                </Grid>

                                <Grid item xs={12} sm={6} md={6}>
                                  <Box className="form-control">
                                    <label className="form-label" htmlFor="bankId">Bank ID</label>
                                    <Field
                                      disabled={dataById?.onBoardingStep === 5 && dataById?.isOnBoarded === true}
                                      id="bankId"
                                      type="text"
                                      placeholder="Enter Bank ID"
                                      name="bankId"
                                      className="form-input"
                                    />
                                    {errors.bankId && <Box className="form-error">{errors.bankId}</Box>}
                                  </Box>
                                </Grid>

                                <Grid item xs={12} sm={6} md={6}>
                                  <Box className="form-control">
                                    <label className="form-label" htmlFor="arn">ARN</label>
                                    <Field
                                      disabled={dataById?.onBoardingStep === 5 && dataById?.isOnBoarded === true}
                                      id="arn"
                                      type="text"
                                      placeholder="Enter ARN"
                                      name="arn"
                                      className="form-input"
                                    />
                                    {errors.arn && <Box className="form-error">{errors.arn}</Box>}
                                  </Box>
                                </Grid>
                              </>
                              {/* )} */}


                            </Grid>
                          </Box>
                        </SectionCard>

                        <Box className="form-button-section">
                          <Link to='/employer'>
                            <Button className="form-button"
                              variant="contained"
                              color="error"
                              disabled={dataById?.onBoardingStep === 5 && dataById?.isOnBoarded === true}
                            >Cancel</Button>
                          </Link>

                          <Button className="form-button"
                            variant="contained"
                            type="submit"
                            color="success"
                            disabled={form2Submitted || disableSubmitBtnTrue || (dataById?.onBoardingStep === 5 && dataById?.isOnBoarded === true)}
                          >
                            {form2Submitted ? <CircularProgress size={24} /> : "Submit"}
                          </Button>

                        </Box>
                      </Form>
                    )}
                  </Formik>
                </Box>
              </>
            )}

            {/* Tab 2: Credit Settings - Only visible in edit mode */}
            {edit && dataById._id && tabValue === 1 && (
              <Box className="create-employer-form-wrapper" style={{ marginTop: "20px" }}>
                {/* Credit Balance Display */}
                <Box sx={{ mb: 3, p: 3, backgroundColor: '#f5f5f5', borderRadius: 2 }}>
                  <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                    Current Credit Balance
                  </Typography>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} md={3}>
                      <Box sx={{ p: 2, backgroundColor: '#e1f5fe', borderRadius: 2 }}>
                        <Typography variant="caption" color="textSecondary">Total HC</Typography>
                        <Typography variant="h5" sx={{ fontWeight: 700, color: '#0277bd' }}>
                          {dataById?.hiringCredits?.totalHiringCredit || 0}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <Box sx={{ p: 2, backgroundColor: '#e8f5e9', borderRadius: 2 }}>
                        <Typography variant="caption" color="textSecondary">Available HC</Typography>
                        <Typography variant="h5" sx={{ fontWeight: 700, color: '#2e7d32' }}>
                          {dataById?.hiringCredits?.remainingHiringCredit || 0}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <Box sx={{ p: 2, backgroundColor: '#f3e5f5', borderRadius: 2 }}>
                        <Typography variant="caption" color="textSecondary">Total PHC</Typography>
                        <Typography variant="h5" sx={{ fontWeight: 700, color: '#6a1b9a' }}>
                          {dataById?.plusHiringCredits?.totalPHC || 0}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <Box sx={{ p: 2, backgroundColor: '#fce4ec', borderRadius: 2 }}>
                        <Typography variant="caption" color="textSecondary">Available PHC</Typography>
                        <Typography variant="h5" sx={{ fontWeight: 700, color: '#c2185b' }}>
                          {dataById?.plusHiringCredits?.availablePHC || 0}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>

                {/* Credit Management Form */}
                <Box sx={{ p: 3, backgroundColor: 'white', borderRadius: 2, boxShadow: 1 }}>
                  <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>
                    Manage Credits
                  </Typography>
                  <Formik
                    initialValues={creditFormInitialValues}
                    validationSchema={AddEmployerCreditsValidationSchema}
                    onSubmit={handleCreditFormSubmit}
                    enableReinitialize
                  >
                    {({ values, errors, touched, handleChange, handleBlur, setFieldValue, isSubmitting, resetForm }) => (
                      <Form>
                        <FocusError handleSnackBar={handleSnackBar} />
                        <Grid container spacing={2} className='cstmFormGridEmployer'>
                          {/* Credit Mode Selection */}
                          <Grid item xs={12}>
                            <FormControl component="fieldset">
                              <FormLabel component="legend">Credit Mode</FormLabel>
                              <RadioGroup
                                row
                                name="creditMode"
                                value={values.creditMode}
                                onChange={(e) => {
                                  const newMode = e.target.value;
                                  setFieldValue('creditMode', newMode);
                                  if (newMode === 'custom') {
                                    setFieldValue('addonId', '');
                                    setFieldValue('hasPaymentTransaction', false);
                                  } else {
                                    setFieldValue('creditAmount', '');
                                    setFieldValue('validityDays', '');
                                    setFieldValue('operation', 'credit');
                                    setFieldValue('hasPaymentTransaction', true);
                                    fetchAddons(values.creditType);
                                  }
                                }}
                              >
                                <FormControlLabel value="custom" control={<Radio />} label="Custom Credits" />
                                <FormControlLabel value="addon" control={<Radio />} label="Use Addon Pack" />
                              </RadioGroup>
                            </FormControl>
                          </Grid>

                          {/* Credit Type */}
                          <Grid item xs={12} sm={6} md={4}>
                            <FormControl fullWidth required error={touched.creditType && Boolean(errors.creditType)}>
                              <InputLabel>Credit Type</InputLabel>
                              <Select
                                name="creditType"
                                value={values.creditType}
                                onChange={(e) => {
                                  handleChange(e);
                                  if (values.creditMode === 'addon') {
                                    setFieldValue('addonId', '');
                                    fetchAddons(e.target.value);
                                  }
                                }}
                                onBlur={handleBlur}
                                label="Credit Type"
                              >
                                <MenuItem value={1}>HC (Hiring Credits)</MenuItem>
                                <MenuItem value={2}>PHC (Plus Hiring Credits)</MenuItem>
                              </Select>
                              {touched.creditType && errors.creditType && (
                                <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
                                  {errors.creditType}
                                </Typography>
                              )}
                            </FormControl>
                          </Grid>

                          {/* Custom Credit Fields */}
                          {values.creditMode === 'custom' && (
                            <>
                              <Grid item xs={12} sm={6} md={4}>
                                <TextField
                                  fullWidth
                                  label="Amount"
                                  name="creditAmount"
                                  type="number"
                                  value={values.creditAmount}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  error={touched.creditAmount && Boolean(errors.creditAmount)}
                                  helperText={touched.creditAmount && errors.creditAmount}
                                  InputProps={{ inputProps: { min: 0 } }}
                                />
                              </Grid>

                              <Grid item xs={12} sm={6} md={4}>
                                <TextField
                                  fullWidth
                                  label="Validity Days"
                                  name="validityDays"
                                  type="number"
                                  value={values.validityDays}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  error={touched.validityDays && Boolean(errors.validityDays)}
                                  helperText={
                                    (touched.validityDays && errors.validityDays) ||
                                    (values.operation === 'debit' ? 'Not required for debit operation' : '')
                                  }
                                  InputProps={{ inputProps: { min: 0 } }}
                                />
                              </Grid>
                            </>
                          )}

                          {/* Addon Pack Selection */}
                          {values.creditMode === 'addon' && (
                            <Grid item xs={12} sm={6} md={4}>
                              <FormControl fullWidth required disabled={loadingAddons} error={touched.addonId && Boolean(errors.addonId)}>
                                <InputLabel>Select Addon Pack</InputLabel>
                                <Select
                                  name="addonId"
                                  value={values.addonId}
                                  onChange={(e) => handleAddonChange(e, setFieldValue, values.creditType)}
                                  onBlur={handleBlur}
                                  label="Select Addon Pack"
                                >
                                  {loadingAddons ? (
                                    <MenuItem disabled>Loading...</MenuItem>
                                  ) : addonList.length === 0 ? (
                                    <MenuItem disabled>No addon packs available</MenuItem>
                                  ) : (
                                    addonList.map((addon) => (
                                      <MenuItem key={addon._id} value={addon._id}>
                                        {addon.addonPackName} - ₹{addon.amount} ({values.creditType === 1 ? addon.hcCredit : addon.hcCredit || 0} credits, {addon.expiryDuration} days)
                                      </MenuItem>
                                    ))
                                  )}
                                </Select>
                                {touched.addonId && errors.addonId && (
                                  <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
                                    {errors.addonId}
                                  </Typography>
                                )}
                              </FormControl>
                            </Grid>
                          )}

                          {/* Operation */}
                          <Grid item xs={12} sm={6} md={4}>
                            <FormControl fullWidth required disabled={values.creditMode === 'addon'} error={touched.operation && Boolean(errors.operation)}>
                              <InputLabel>Operation</InputLabel>
                              <Select
                                name="operation"
                                value={values.operation}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                label="Operation"
                              >
                                <MenuItem value="credit">Credit</MenuItem>
                                <MenuItem value="debit">Debit</MenuItem>
                              </Select>
                              {touched.operation && errors.operation && (
                                <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
                                  {errors.operation}
                                </Typography>
                              )}
                            </FormControl>
                            {values.creditMode === 'addon' && (
                              <Typography variant="caption" color="textSecondary" sx={{ mt: 0.5 }}>
                                Operation is always "Credit" for addon packs
                              </Typography>
                            )}
                          </Grid>

                          <Grid item xs={12} sm={6} md={4}>
                            <FormControl fullWidth required error={touched.reason && Boolean(errors.reason)}>
                              <InputLabel>Reason</InputLabel>
                              <Select
                                name="reason"
                                value={values.reason}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                label="Reason"
                              >
                                <MenuItem value="Credited as welcome bonus.">Credited as welcome bonus.</MenuItem>
                                <MenuItem value="Promotional credits added.">Promotional credits added.</MenuItem>
                                <MenuItem value="Added after successful payment.">Added after successful payment.</MenuItem>
                                <MenuItem value="Credited by JobsYahan support.">Credited by JobsYahan support.</MenuItem>
                                <MenuItem value="Adjusted as per account review.">Adjusted as per account review.</MenuItem>
                                <MenuItem value="Debited by JobsYahan support.">Debited by JobsYahan support.</MenuItem>
                              </Select>
                              {touched.reason && errors.reason && (
                                <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
                                  {errors.reason}
                                </Typography>
                              )}
                            </FormControl>
                          </Grid>

                          <Grid item xs={12}>
                            <TextField
                              fullWidth
                              label="System Message"
                              name="systemMessage"
                              multiline
                              rows={3}
                              value={values.systemMessage}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              error={touched.systemMessage && Boolean(errors.systemMessage)}
                              helperText={touched.systemMessage && errors.systemMessage}
                              placeholder="Enter message for credit/debit operation"
                            />
                          </Grid>

                          {/* Payment Transaction Toggle */}
                          <Grid item xs={12}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  name="hasPaymentTransaction"
                                  checked={values.hasPaymentTransaction}
                                  onChange={(e) => {
                                    setFieldValue('hasPaymentTransaction', e.target.checked);
                                  }}
                                  disabled={values.creditMode === 'addon' || values.operation === 'debit'}
                                />
                              }
                              label="Has Payment Transaction Details"
                            />
                            {values.creditMode === 'addon' && (
                              <Typography variant="caption" color="textSecondary" sx={{ ml: 4, display: 'block' }}>
                                Payment transaction details are mandatory for addon packs
                              </Typography>
                            )}
                          </Grid>

                          {/* Payment Transaction Fields */}
                          {values.hasPaymentTransaction && (
                            <>
                              <Grid item xs={12} sm={6} md={4}>
                                <TextField
                                  fullWidth
                                  label="Payment Amount"
                                  name="amount"
                                  type="number"
                                  value={values.amount}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  error={touched.amount && Boolean(errors.amount)}
                                  helperText={touched.amount && errors.amount}
                                  InputProps={{ inputProps: { min: 0 } }}
                                />
                              </Grid>

                              <Grid item xs={12} sm={6} md={4}>
                                <FormControl fullWidth error={touched.paymentMode && Boolean(errors.paymentMode)}>
                                  <InputLabel>Payment Mode</InputLabel>
                                  <Select
                                    name="paymentMode"
                                    value={values.paymentMode}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    label="Payment Mode"
                                  >
                                    <MenuItem value="">Select Payment Mode</MenuItem>
                                    <MenuItem value="UPI">UPI</MenuItem>
                                    <MenuItem value="NEFT">NEFT</MenuItem>
                                    <MenuItem value="RTGS">RTGS</MenuItem>
                                    <MenuItem value="IMPS">IMPS</MenuItem>
                                    <MenuItem value="Card">Card</MenuItem>
                                    <MenuItem value="Net Banking">Net Banking</MenuItem>
                                    <MenuItem value="Cash">Cash</MenuItem>
                                    <MenuItem value="Cheque">Cheque</MenuItem>
                                  </Select>
                                  {touched.paymentMode && errors.paymentMode && (
                                    <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
                                      {errors.paymentMode}
                                    </Typography>
                                  )}
                                </FormControl>
                              </Grid>

                              <Grid item xs={12} sm={6} md={4}>
                                <TextField
                                  fullWidth
                                  label="Bank Transaction ID"
                                  name="bankTransactionId"
                                  value={values.bankTransactionId}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  error={touched.bankTransactionId && Boolean(errors.bankTransactionId)}
                                  helperText={touched.bankTransactionId && errors.bankTransactionId}
                                />
                              </Grid>

                              <Grid item xs={12} sm={6} md={4}>
                                <TextField
                                  fullWidth
                                  label="Payment Gateway Transaction ID"
                                  name="paymentGatewayTransactionId"
                                  value={values.paymentGatewayTransactionId}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                />
                              </Grid>

                              <Grid item xs={12} sm={6} md={4}>
                                <TextField
                                  fullWidth
                                  label="Payment Gateway Service Transaction ID"
                                  name="paymentGatewayServiceTransactionId"
                                  value={values.paymentGatewayServiceTransactionId}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                />
                              </Grid>

                              <Grid item xs={12} sm={6} md={4}>
                                <TextField
                                  fullWidth
                                  label="Bank ID"
                                  name="bankId"
                                  value={values.bankId}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                />
                              </Grid>

                              <Grid item xs={12} sm={6} md={4}>
                                <TextField
                                  fullWidth
                                  label="ARN"
                                  name="arn"
                                  value={values.arn}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                />
                              </Grid>
                            </>
                          )}

                          {/* Submit and Reset Buttons */}
                          <Grid item xs={12}>
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                              <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                disabled={isSubmitting}
                              >
                                {isSubmitting ? `${values.operation === "credit" ? "Crediting..." : "Debiting..."}` : `${values.operation}`}
                              </Button>
                              <Button
                                type="button"
                                variant="outlined"
                                color="secondary"
                                onClick={() => {
                                  resetForm();
                                  setAddonList([]);
                                }}
                              >
                                Reset
                              </Button>
                            </Box>
                          </Grid>
                        </Grid>
                      </Form>
                    )}
                  </Formik>
                </Box>
              </Box>
            )}
          </Box>
        </Container>

      </Box >}
    </> : (<Unauthorized />)

  )

}
export default CreateRecruiter;